// extracted by css-extract-rspack-plugin
export default {"notificationListItem":"ShV2b","itemTitle":"wxLOw","notificationListItemEditable":"yyRKm","handlersContainer":"AnG6w","actionButtonContainer":"nN6mg"};